import { Injectable } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

export type OsIconNames =
  | 'os-aws'
  | 'os-centos'
  | 'os-debian'
  | 'os-docker'
  | 'os-redhat'
  | 'os-ubuntu'
  | 'os-windows'
  | 'os-linux';

@Injectable({
  providedIn: 'root',
})
export class OsIconsService {
  constructor(iconRegistry: MatIconRegistry, sanitizer: DomSanitizer) {
    iconRegistry.addSvgIcon(
      'os-aws',
      sanitizer.bypassSecurityTrustResourceUrl('assets/aws.svg')
    );
    iconRegistry.addSvgIcon(
      'os-centos',
      sanitizer.bypassSecurityTrustResourceUrl('assets/centos.svg')
    );
    iconRegistry.addSvgIcon(
      'os-debian',
      sanitizer.bypassSecurityTrustResourceUrl('assets/debian.svg')
    );
    iconRegistry.addSvgIcon(
      'os-docker',
      sanitizer.bypassSecurityTrustResourceUrl('assets/docker.svg')
    );
    iconRegistry.addSvgIcon(
      'os-linux',
      sanitizer.bypassSecurityTrustResourceUrl('assets/linux.svg')
    );
    iconRegistry.addSvgIcon(
      'os-redhat',
      sanitizer.bypassSecurityTrustResourceUrl('assets/redhat.svg')
    );
    iconRegistry.addSvgIcon(
      'os-ubuntu',
      sanitizer.bypassSecurityTrustResourceUrl('assets/ubuntu.svg')
    );
    iconRegistry.addSvgIcon(
      'os-windows',
      sanitizer.bypassSecurityTrustResourceUrl('assets/windows.svg')
    );
    iconRegistry.addSvgIcon(
      'os-aws-color',
      sanitizer.bypassSecurityTrustResourceUrl('assets/color/aws.svg')
    );
    iconRegistry.addSvgIcon(
      'os-cen-color',
      sanitizer.bypassSecurityTrustResourceUrl('assets/color/cen.svg')
    );
    iconRegistry.addSvgIcon(
      'os-debian-color',
      sanitizer.bypassSecurityTrustResourceUrl('assets/color/debian.svg')
    );
    iconRegistry.addSvgIcon(
      'os-docker-color',
      sanitizer.bypassSecurityTrustResourceUrl('assets/color/docker.svg')
    );
    iconRegistry.addSvgIcon(
      'os-linux-color',
      sanitizer.bypassSecurityTrustResourceUrl('assets/color/linux.svg')
    );
    iconRegistry.addSvgIcon(
      'os-redhat-color',
      sanitizer.bypassSecurityTrustResourceUrl('assets/color/redhat.svg')
    );
    iconRegistry.addSvgIcon(
      'os-ubuntu-color',
      sanitizer.bypassSecurityTrustResourceUrl('assets/color/ubuntu.svg')
    );
    iconRegistry.addSvgIcon(
      'os-windows-color',
      sanitizer.bypassSecurityTrustResourceUrl('assets/color/windows.svg')
    );
  }

  stringMap = [
    { icon: 'os-aws', regex: /^(.*(?<!brand-))(amazon|aws)/i },
    { icon: 'os-centos', regex: /^(.*(?<!brand-))(centos|cent os)/i },
    { icon: 'os-debian', regex: /^(.*(?<!brand-))(debian)/i },
    { icon: 'os-docker', regex: /^(.*(?<!brand-))(docker|kubernetes)/i },
    { icon: 'os-redhat', regex: /^(.*(?<!brand-))(red hat|redhat)/i },
    { icon: 'os-ubuntu', regex: /^(.*(?<!brand-))(ubuntu)/i },
    { icon: 'os-windows', regex: /^(.*(?<!brand-))(windows|microsoft)/i },
    { icon: 'os-linux', regex: /^(.*(?<!brand-))(linux)/i }, // keep this general 'linux' check at the end
  ];

  getIcon(input: string, fullColor = false) {
    const { icon = null } =
      this.stringMap.find((i) => i.regex.test(input)) || {};
    return fullColor ? `${icon}-color` : icon;
  }
}
